import React from "react";
import "../css/Footer3.css";

const Footer3 = () => {
  return (
    <footer className="footer3">

      {/* Top Divider Line */}
      <div className="footer3-line"></div>

      <div className="footer3-container">

        {/* LEFT BLOCK — BRAND + SLOGAN */}
        <div className="footer3-brand">
          <h1>ACE</h1>
          <p>Performance begins with discipline.</p>
        </div>

        {/* CENTER NAVIGATION */}
        <div className="footer3-nav">
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/plans">Membership</a>
          <a href="/faqs">FAQs</a>
          <a href="/contact">Contact</a>
          <a href="/trainers">Trainers</a>
          <a href="/workouts">Workouts</a>
          <a href="/services">Services</a>
          <a href="/gallery">Gallery</a>
        </div>

        {/* RIGHT BLOCK — SOCIAL + COPYRIGHT */}
        <div className="footer3-social">
          <div className="social-links">
            <a href="#">IG</a>
            <a href="#">YT</a>
            <a href="#">FB</a>
            <a href="#">TW</a>
          </div>

          <p className="copy">© 2025 ACE FITNESS. All rights reserved.</p>
        </div>

      </div>

    </footer>
  );
};

export default Footer3;
